unit View.Rt_Is_Cst.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UHelperServer, System.StrUtils, UConstantes, UWeb.Enum, UUtils,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewRt_Is_CstList = class(TForm)
    btNew: TButton;
    Rt_Is_CstDataset: TXDataWebDataSet;
    Rt_Is_CstDatasetid: TIntegerField;
    Rt_Is_CstDatasetcst: TStringField;
    Rt_Is_CstDatasetdescricao: TStringField;
    Rt_Is_CstDatasetexcluido: TBooleanField;
    Rt_Is_CstDatasetinclusao: TDateTimeField;
    Rt_Is_CstDatasetalteracao: TDateTimeField;
    Rt_Is_CstDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebFormShow(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewRt_Is_CstList: TFViewRt_Is_CstList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewRt_Is_CstList }

procedure TFViewRt_Is_CstList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewRt_Is_CstList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewRt_Is_CstList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewRt_Is_CstList, AElementID, Result, @AfterCreate);
end;

procedure TFViewRt_Is_CstList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewRt_Is_CstList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewRt_Is_CstList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewRt_Is_CstList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewRt_Is_CstList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Rt_Is_CstDataset.Connection.Model.DefaultSchema.FindEntityType(Rt_Is_CstDataset.EntitySetName),
      Rt_Is_CstDataset.CurrentData
    );

    Button := TButton.Create(nil);

    if TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
      Button.Caption := '<i class="fa fa-edit"></i>'
    else
      Button.Caption := '<i class="fa fa-eye"></i>';

    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_rt_is_cst');
  end;
end;

procedure TFViewRt_Is_CstList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['descricao']) of
      0: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewRt_Is_CstList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido', 'descricao']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1:
      begin
        if Length(AValue) > 100 then
          AValue := Copy(AValue, 1, 100) + '...';
      end;
    end;
  end;
end;

procedure TFViewRt_Is_CstList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('rt_is_cst', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetValorDicionarioClasses('reforma_tributaria_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_reforma_tributaria', 'active');

  TUtils.SetPaginaSelecionada;

  if not TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
    THelperServer.RemoverElementoPorId('view.rt_is_cst.list.newbutton');

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Rt_Is_CstDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewRt_Is_CstList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Rt_Is_CstDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewRt_Is_CstList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.rt_is_cst.list.pagination.info');
  btNew := TButton.Create('view.rt_is_cst.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.rt_is_cst.list.table');
  cbPageSize := TComboBox.Create('view.rt_is_cst.list.cbPageSize');
  edSearch := TEdit.Create('view.rt_is_cst.list.search');
  lcPaginator := TListControl.Create('view.rt_is_cst.list.pagination');
  Rt_Is_CstDataset := TXDataWebDataSet.Create(Self);
  Rt_Is_CstDatasetid := TIntegerField.Create(Self);
  Rt_Is_CstDatasetcst := TStringField.Create(Self);
  Rt_Is_CstDatasetdescricao := TStringField.Create(Self);
  Rt_Is_CstDatasetexcluido := TBooleanField.Create(Self);
  Rt_Is_CstDatasetinclusao := TDateTimeField.Create(Self);
  Rt_Is_CstDatasetalteracao := TDateTimeField.Create(Self);
  Rt_Is_CstDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Rt_Is_CstDataset.BeforeLoadDFMValues;
  Rt_Is_CstDatasetid.BeforeLoadDFMValues;
  Rt_Is_CstDatasetcst.BeforeLoadDFMValues;
  Rt_Is_CstDatasetdescricao.BeforeLoadDFMValues;
  Rt_Is_CstDatasetexcluido.BeforeLoadDFMValues;
  Rt_Is_CstDatasetinclusao.BeforeLoadDFMValues;
  Rt_Is_CstDatasetalteracao.BeforeLoadDFMValues;
  Rt_Is_CstDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewRt_Is_CstList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst';
      Title := 'cst';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Rt_Is_CstDataset.SetParentComponent(Self);
    Rt_Is_CstDataset.Name := 'Rt_Is_CstDataset';
    Rt_Is_CstDataset.EntitySetName := 'Rt_Is_Cst';
    Rt_Is_CstDataset.Connection := DMConnection.ApiConnection;
    Rt_Is_CstDataset.Left := 72;
    Rt_Is_CstDataset.Top := 144;
    Rt_Is_CstDatasetid.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetid.Name := 'Rt_Is_CstDatasetid';
    Rt_Is_CstDatasetid.FieldName := 'id';
    Rt_Is_CstDatasetid.Required := True;
    Rt_Is_CstDatasetcst.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetcst.Name := 'Rt_Is_CstDatasetcst';
    Rt_Is_CstDatasetcst.FieldName := 'cst';
    Rt_Is_CstDatasetcst.Required := True;
    Rt_Is_CstDatasetcst.Size := 255;
    Rt_Is_CstDatasetdescricao.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetdescricao.Name := 'Rt_Is_CstDatasetdescricao';
    Rt_Is_CstDatasetdescricao.FieldName := 'descricao';
    Rt_Is_CstDatasetdescricao.Required := True;
    Rt_Is_CstDatasetdescricao.Size := 255;
    Rt_Is_CstDatasetexcluido.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetexcluido.Name := 'Rt_Is_CstDatasetexcluido';
    Rt_Is_CstDatasetexcluido.FieldName := 'excluido';
    Rt_Is_CstDatasetinclusao.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetinclusao.Name := 'Rt_Is_CstDatasetinclusao';
    Rt_Is_CstDatasetinclusao.FieldName := 'inclusao';
    Rt_Is_CstDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Is_CstDatasetalteracao.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetalteracao.Name := 'Rt_Is_CstDatasetalteracao';
    Rt_Is_CstDatasetalteracao.FieldName := 'alteracao';
    Rt_Is_CstDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Is_CstDatasetexclusao.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetexclusao.Name := 'Rt_Is_CstDatasetexclusao';
    Rt_Is_CstDatasetexclusao.FieldName := 'exclusao';
    Rt_Is_CstDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Rt_Is_CstDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Rt_Is_CstDataset.AfterLoadDFMValues;
    Rt_Is_CstDatasetid.AfterLoadDFMValues;
    Rt_Is_CstDatasetcst.AfterLoadDFMValues;
    Rt_Is_CstDatasetdescricao.AfterLoadDFMValues;
    Rt_Is_CstDatasetexcluido.AfterLoadDFMValues;
    Rt_Is_CstDatasetinclusao.AfterLoadDFMValues;
    Rt_Is_CstDatasetalteracao.AfterLoadDFMValues;
    Rt_Is_CstDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
